import { Badge } from "@/components/ui/badge";
import type { TopPlayer } from "@/types/api.types";

const POSITION_COLORS: Record<string, string> = {
  GK: "bg-yellow-100 text-yellow-800",
  DEF: "bg-blue-100 text-blue-800",
  MID: "bg-green-100 text-green-800",
  FWD: "bg-red-100 text-red-800",
};

export default function TopPlayersCard({ players }: { players: TopPlayer[] }) {
  if (players.length === 0) {
    return (
      <div className="bg-white rounded-xl border p-12 text-center text-gray-400">
        No player data yet
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl border overflow-hidden">
      <div className="px-4 py-3 bg-gray-50 border-b">
        <p className="text-sm font-semibold text-gray-700">
          🏆 Highest Scoring Players
        </p>
      </div>

      {players.map((player, index) => (
        <div
          key={player.id}
          className="flex items-center gap-4 px-4 py-3 border-b last:border-0 hover:bg-gray-50 transition"
        >
          {/* Rank */}
          <span className="w-6 text-center text-sm font-bold text-gray-400">
            {index + 1}
          </span>

          {/* Flag */}
          {player.flagUrl ? (
            <img
              src={player.flagUrl}
              className="w-8 h-5 object-cover rounded border"
              alt={player.nation}
            />
          ) : (
            <div className="w-8 h-5 bg-gray-200 rounded" />
          )}

          {/* Player Info */}
          <div className="flex-1">
            <p className="font-semibold text-gray-900 text-sm">{player.name}</p>
            <p className="text-xs text-gray-400">{player.nation}</p>
          </div>

          {/* Position */}
          <Badge className={`text-xs ${POSITION_COLORS[player.position]}`}>
            {player.position}
          </Badge>

          {/* Selected by */}
          <div className="text-right text-xs text-gray-400">
            <p>{player.selectedBy} teams</p>
          </div>

          {/* Points */}
          <div className="text-right min-w-[60px]">
            <span className="text-lg font-black text-gray-900">
              {player.points}
            </span>
            <span className="text-xs text-gray-400 ml-1">pts</span>
          </div>
        </div>
      ))}
    </div>
  );
}
